import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { login } from "../services/accountsService";
import { useAuth } from "../contexts/AuthContext";

export const useLoginForm = () => {
    const [form, setForm] = useState({ login_id: "", password: "" });
    const [msg, setMsg] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();
    const { loadUser } = useAuth();

    const handleChange = (e) => {
        setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.login_id || !form.password) {
            setMsg("ログインIDとパスワードを入力してください");
            return;
        }

        setIsSubmitting(true);
        setMsg("");

        try {
            await login(form);
            // ログイン成功後、認証コンテキストのユーザー情報を更新（強制的に実行）
            await loadUser(true);
            navigate("/dashboard/select", { replace: true });
        } catch (err) {
            setMsg(err.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return {
        state: { form, msg, isSubmitting },
        actions: { handleChange, handleSubmit },
    };
};